export default "__VITE_ASSET__C35HAerp__"